// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__DaURP","label":"Completed_label__1HjeD"};